module.exports = __webpack_public_path__ + "img/693-c431d4.png";